import { useAdminAuth } from "./useAdminAuth";
import { Navigate } from "react-router-dom";

export default function AdminGuard({ children }) {
  const { admin, loading } = useAdminAuth();

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "system-ui",
        }}
      >
        Loading…
      </div>
    );

  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

export function AdminRoleGuard({ roles, children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) return null;
  if (!admin || !roles.includes(admin.role)) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
